import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withI18n, withI18nProps } from '@lingui/react'
import compose from 'lodash/fp/compose'

import { ContactsLayout } from 'client/bookmate/blocks/contacts-layout'
import HeaderBox from 'client/shared/boxes/header-box'

import MetaTitle from 'client/shared/blocks/meta-title'
import { MetaDescription } from 'client/shared/blocks/meta-description'
import { State } from 'shared/types/redux'
import { CurrentUserState, Locale } from 'client/shared/types/current-user'

type Props = { currentUser: CurrentUserState; domain: Locale } & withI18nProps

class ContactsPage extends Component<Props> {
  render() {
    const {
      currentUser: {
        data: { locale },
      },
      domain,
      i18n,
    } = this.props
    return (
      <>
        <MetaTitle title={i18n.t`contacts.head_title`} />
        <MetaDescription description={i18n.t`contacts.title`} />
        <HeaderBox />
        <ContactsLayout locale={locale} domain={domain} />
      </>
    )
  }
}

const wrappers = compose(
  connect((state: State) => ({
    currentUser: state.currentUser,
    domain: state.app.domain,
  })),
  withI18n({ update: true }),
)

export default wrappers(ContactsPage)
